'use client';
import MinusIcon from '@/components/icons/MinusIcon';
import PlusIcon from '@/components/icons/PlusIcon';
import TrashIcon from '@/components/icons/trash';
import useHandleCart from '@/hooks/cart/useHandleCart';

const QtyControlBtns = ({ item, product, page }) => {
  const { loading, handleUpdateCart, deleteItemFromCart } = useHandleCart();

  return (
    <div className='bg-primary flex w-full items-center justify-center rounded-[10px] px-2 py-1.5 text-white'>
      <button
        onClick={() =>
          item?.qty === 1
            ? deleteItemFromCart(item, page)
            : handleUpdateCart(true, item.item_id, item.qty, product)
        }
        disabled={loading === 'subtracting'}
        className={`border-primary-600 hover:bg-primary-800 bg-primary-900 disabled:bg-primary-700 flex min-h-7.5 w-10 cursor-pointer items-center justify-center rounded-s-[10px] border text-white disabled:cursor-not-allowed disabled:opacity-75 max-[360px]:w-8 md:h-10 md:w-12 lg:min-h-[45px]`}
      >
        {loading === 'subtracting' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-white' />
        ) : item?.qty === 1 ? (
          <TrashIcon className='text-white' />
        ) : (
          <MinusIcon className='text-white' />
        )}
      </button>

      <div
        className={`flex min-h-7.5 w-10 cursor-pointer items-center justify-center text-center max-[360px]:w-8 md:h-10 md:w-12 lg:min-h-[45px]`}
      >
        {item?.qty}
      </div>

      <button
        onClick={() => handleUpdateCart(false, item.item_id, item.qty, product)}
        disabled={loading === 'adding'}
        className={`border-primary-600 hover:bg-primary-800 bg-primary-900 disabled:bg-primary-700 flex min-h-7.5 w-10 cursor-pointer items-center justify-center rounded-e-[10px] border disabled:cursor-not-allowed disabled:opacity-75 max-[360px]:w-8 md:h-10 md:w-12 lg:min-h-[45px]`}
      >
        {loading === 'adding' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-white' />
        ) : (
          <PlusIcon />
        )}
      </button>
    </div>
  );
};

export default QtyControlBtns;
